import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

//components
import { Section } from '@/containers-ai/SectionHeading';

export const LiveSection = styled(Section)`
  background: ${homeColor.bg};
`;

export const BigProof = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;

  ${screen.md} {
    flex-direction: row;
    align-items: center;
    gap: 26px;
  }
`;

export const BigProofValue = styled.div`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  font-size: 54px;
  letter-spacing: -0.03em;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const BigProofText = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 17px;
  line-height: 1.6;
  color: ${homeColor.muted};
  margin: 0;

  b {
    color: ${homeColor.white};
    font-weight: 600;
  }
`;

export const ExceptionsBanner = styled.div`
  background: rgba(245, 181, 68, 0.05);
  border: 1px solid ${homeColor.amber};
  border-radius: 12px;
  padding: 14px 20px;
  text-align: center;
  margin-top: 26px;
`;

export const ExceptionsBannerText = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 17px;
  color: ${homeColor.amber};
  margin: 0;
`;

export const TaskGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  margin-top: 26px;

  ${screen.md} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${screen.lg} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const TaskCard = styled.div`
  background: rgba(12, 35, 40, 0.5);
  border: 1px solid rgba(20, 213, 77, 0.16);
  border-radius: 14px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TaskTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  color: ${homeColor.white};
  font-size: 18px;
  margin: 0;
`;

export const TaskDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
`;

export const TaskMetricWrap = styled.div`
  border-top: 1px solid ${homeColor.carbon};
  padding-top: 14px;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const TaskMetric = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 24px;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0;
`;

export const TaskMetricLabel = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 11px;
  margin: 0;
`;

export const CustomCard = styled.div`
  border: 1px solid ${homeColor.cyan};
  border-radius: 14px;
  padding: 26px 22px;
  margin-top: 26px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 0 20px 0 rgba(20, 214, 77, 0.25);
  background:
    linear-gradient(
      90deg,
      rgba(0, 215, 215, 0.1) 0%,
      rgba(20, 213, 77, 0.1) 55%,
      rgba(132, 241, 30, 0.1) 100%
    ),
    rgba(12, 35, 40, 0.5);

  ${screen.lg} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const CustomCardKicker = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  color: ${homeColor.green};
  font-size: 11px;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  margin: 0 0 5px;
`;

export const CustomCardTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 700;
  font-size: 26px;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0 0 8px;
`;

export const CustomCardCopy = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 15px;
  margin: 0;
  max-width: 48ch;
`;

export const PlusDivider = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${getToken('font-family-default')};
  font-weight: 800;
  color: ${homeColor.green};
  margin: 8px 0;
  font-size: 42px;

  ${screen.lg} {
    font-size: 62px;
  }
`;

export const SummaryRow = styled.div`
  display: grid;
  gap: 20px;
  align-items: center;

  ${screen.lg} {
    grid-template-columns: 1fr 55%;
    align-items: center;
  }
`;

export const SummaryTitle = styled.p`
  font-family: ${getToken('font-family-title')};
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.02em;
  color: ${homeColor.white};
  margin: 0;
  flex: 1;

  ${screen.lg} {
    font-size: 27px;
  }

  ${screen.xxlg} {
    font-size: 32px;
  }

  span {
    background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const SummaryPanel = styled.div`
  border: 1px solid ${homeColor.cyan};
  border-radius: 14px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const SummaryValue = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 800;
  font-size: 51px;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin: 0;
`;

export const SummaryCopy = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.white};
  font-size: 15px;
  line-height: 1.6;
  margin: 0;

  b {
    font-weight: 800;
  }
`;
